import type { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { useCapacityManagement } from 'src/apis/capacity-management/use-capacity-management';
import { Link } from 'src/components/navigation/link';
import { Tabs } from 'src/components/navigation/tabs';

export const OperatorsTabs: FC = () => {
  const capacityManagement = useCapacityManagement();
  const { pathname } = useLocation();
  return (
    <Tabs className="print:hidden">
      <Link
        to="/operators/assignments"
        isActive={
          pathname.startsWith('/operators/assignments') ||
          pathname.startsWith('/dashboard/operators/assignments')
        }
      >
        Assignments
      </Link>

      <Link to="/operators/operator-documents">Documents</Link>

      {!!capacityManagement?._links?.myInvoicesV2 && (
        <Link to="/operators/invoices">Invoices</Link>
      )}
    </Tabs>
  );
};
